// extracted by mini-css-extract-plugin
module.exports = {"container":"LrvSwitch_container__32Pgx","darkContainer":"LrvSwitch_darkContainer__2rR9h","lightContainer":"LrvSwitch_lightContainer__2JKnq"};